import React, { useEffect } from "react";

import * as S from "./styles";

export const BannerLP: React.FC = () => {
  const animateBanner = {
    symbolBig: {
      scale: [1, 1.025, 1],
      rotate: [0, 90, 0],
      transition: { ease: "easeInOut", duration: 8, repeat: Infinity },
    },
    ball: {
      scale: [1, 1.2, 1],
      transition: { ease: "easeInOut", duration: 4, repeat: Infinity },
    },
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://d335luupugsy2.cloudfront.net/js/rdstation-forms/stable/rdstation-forms.min.js";
    script.async = true;

    script.onload = () => {
      if ((window as any).RDStationForms) {
        new (window as any).RDStationForms(
          "op_tijuca-b5883f5893e2e6e2e8d6",
          "null"
        ).createForm();
      }
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <S.Container>
      <S.Content>
        <S.Wrapper>
          <S.Title>
            Conheça a ortodontia <span>orthopride!</span>
          </S.Title>
          <S.Text>
            Preencha o formulário ao lado para que nossa equipe entre em contato
            com você
          </S.Text>
        </S.Wrapper>
        {/* <S.Modelo /> */}
        <S.GroupCrmForm>
          <div role="main" id="op_tijuca-b5883f5893e2e6e2e8d6" />
        </S.GroupCrmForm>
      </S.Content>
    </S.Container>
  );
};
